import React, { Component } from 'react';

export default class Redirect extends Component {
  constructor(props) {
    super(props);
    window.location.replace('/dashboard/security');
  }

  render() {

    return (
      <div>

      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/redirect.js